module.exports = __webpack_public_path__ + "img/Group 427320370.ed3e3f1c.svg";